import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../services/api";
import axios from "axios";
import VariantButton from "../../../../components/variant-button/variant-button";

export default function ListBlog() {
  const [permissions, setPermissions] = useState(undefined);
  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      const res = await api.get("/users/permissions");
      setPermissions(res.data.data);
    } catch (error) {}
  };

  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [blogsPerPage] = useState(5);
  const [featuredList, setFeaturedList] = useState([]);

  useEffect(() => {
    permissions && permissions.includes("blogs.view") && fetchBlogs();
  }, [permissions]);

  const fetchBlogs = async () => {
    try {
      const [blogsRes, featuredRes] = await Promise.all([
        api.get("/blogs"),
        api.get("/blogs/featured"),
      ]);

      const blogData = blogsRes.data.data || [];
      const featuredData = featuredRes.data.data || [];

      const updatedBlogs = blogData
        .map((blog) => ({
          ...blog,
          featured: featuredData.some((featured) => featured.id === blog.id),
        }))
        .sort((a, b) => Number(b.featured) - Number(a.featured));

      setFeaturedList(featuredData);
      setBlogs(updatedBlogs);
      setFilteredBlogs(updatedBlogs);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setCurrentPage(1);

    const filtered = blogs.filter(
      (blog) =>
        blog.title.toLowerCase().includes(query) ||
        blog.author.toLowerCase().includes(query) ||
        blog.locale.toLowerCase().includes(query) ||
        (blog.slug && blog.slug.toLowerCase().includes(query)) ||
        (blog.type && blog.type.toLowerCase().includes(query)) ||
        new Date(blog.created_at).toLocaleDateString().includes(query),
    );
    setFilteredBlogs(filtered);
  };

  const handleLocale = (locale) => {
    setCurrentPage(1);
    if (locale === "") {
      setFilteredBlogs(blogs);
      return;
    }
    const filtered = blogs.filter((blog) => blog.locale === locale);
    setFilteredBlogs(filtered);
  };

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [deletingId, setDeletingId] = useState(null);

  const handleDelete = async (id) => {
    alert("xoá");
    setDeletingId(id);
    try {
      // Express deletes only the MySQL blog, then returns the unused image
      // URLs recorded in blog_images. It does not connect to PocketBase.
      const response = await api.delete(`/blogs/${id}`);
      const deletion = response.data?.data;
      if (!deletion?.success) {
        throw new Error("Không thể xoá blog trong MySQL.");
      }

      const imageUrls = [...new Set(deletion.imageUrls || [])];
      const url = (process.env.REACT_APP_POCKETBASE || "").replace(/\/+$/, "");
      let deletedImages = 0;
      let failedImages = 0;
      let skippedImages = 0;

      if (imageUrls.length) {
        try {
          // Same PocketBase authentication as the ImageUpload component.
          const auth = await axios.post(
            `${url}/api/collections/_superusers/auth-with-password`,
            {
              identity: process.env.REACT_APP_IDENTITY,
              password: process.env.REACT_APP_PASSWORD,
            },
          );
          const { token } = auth.data;
          if (!token) throw new Error("PocketBase không trả về token.");

          for (const image_url of imageUrls) {
            try {
              const image = new URL(image_url);
              const base = new URL(url);
              const prefix =
                base.pathname.replace(/\/+$/, "") + "/api/files/blog_images/";
              const parts = image.pathname.startsWith(prefix)
                ? image.pathname.slice(prefix.length).split("/")
                : [];

              // Delete only files in the configured blog_images collection.
              if (
                image.origin !== base.origin ||
                parts.length !== 2 ||
                !/^[a-zA-Z0-9_-]{5,64}$/.test(parts[0]) ||
                !parts[1]
              ) {
                skippedImages++;
                continue;
              }

              try {
                await axios.delete(
                  `${url}/api/collections/blog_images/records/${parts[0]}`,
                  { headers: { Authorization: token } },
                );
              } catch (error) {
                // If PocketBase already deleted the image, still clear its
                // obsolete MySQL tracking record.
                if (error.response?.status !== 404) throw error;
              }

              // Remove the corresponding MySQL record only after the
              // PocketBase deletion succeeds (or the file is already gone).
              await api.delete("/blogs/images", {
                data: { image_url },
              });
              deletedImages++;
            } catch (error) {
              failedImages++;
              console.error("Không thể xoá ảnh blog:", image_url, error);
            }
          }
        } catch (error) {
          failedImages += imageUrls.length;
          console.error("Không thể xác thực PocketBase để xoá ảnh:", error);
        }
      }

      await fetchBlogs();
      if (currentBlogs.length === 1 && currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }

      const warnings = [...(deletion.warnings || [])];
      if (failedImages || skippedImages) {
        warnings.push(
          `Đã dọn ${deletedImages} ảnh; ${failedImages} ảnh lỗi và ${skippedImages} ảnh không thuộc PocketBase blog_images.`,
        );
      }
      if (warnings.length) {
        window.alert(
          `Đã xoá blog, nhưng có vấn đề khi dọn ảnh:\n${warnings.join("\n")}`,
        );
      }
    } catch (error) {
      console.error("Không thể xoá blog:", error);
      window.alert(
        error.response?.data?.message ||
          error.message ||
          "Không thể xoá blog. Vui lòng thử lại.",
      );
    } finally {
      setDeletingId(null);
    }
  };

  const handleIsFeaured = async (blog) => {
    try {
      const res = await api.put(`/blogs/featured/${blog.id}`, {
        locale: blog.locale,
      });
      if (res.data.data.success) {
        await fetchBlogs();
      }
    } catch (error) {}
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (permissions && !permissions.includes("blogs.view")) {
    return <div></div>;
  }

  if (permissions && loading) {
    return (
      <div className="w-full h-screen flex flex-row justify-center items-center">
        <p className="text-gray-500 text-center py-4 animate-pulse">
          💅 Đang tải dữ liệu…
        </p>
      </div>
    );
  }

  const getPageNumbers = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [];

    pages.push(1);

    if (currentPage > 4) {
      pages.push("...");
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 3) {
      pages.push("...");
    }

    pages.push(totalPages);

    return [...new Set(pages)];
  };
  const languages = [
    {
      code: "vi",
      name: "Tiếng Việt",
    },
    {
      code: "en",
      name: "Tiếng Anh",
    },
    {
      code: "ja",
      name: "Tiếng Nhật",
    },
    {
      code: "zh-Hans",
      name: "Tiếng Trung (Giản thể)",
    },
    {
      code: "zh-Hant",
      name: "Tiếng Trung (Phồn thể)",
    },
  ];
  return (
    permissions && (
      <div className="flex-1 overflow-y-auto p-6 bg-gray-100 min-h-[calc(100vh-20px)] min-w-[1000px]">
        <div className="w-full mx-auto">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">
            Quản lý Blog
          </h1>
          <div className="bg-white shadow-xl rounded-lg p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-semibold text-gray-700">
                Danh sách Blog
              </h2>
              <div className="flex items-center space-x-3">
                <select
                  className="w-fit p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onChange={(e) => {
                    handleLocale(e.target.value);
                  }}
                >
                  <option value={""} key="">
                    Tất cả
                  </option>
                  {languages.map((item) => (
                    <option value={item.code} key={item.code}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <input
                  type="text"
                  placeholder="Tìm theo tiêu đề, slug, loại, tác giả, hoặc ngày tạo..."
                  value={searchQuery}
                  onChange={handleSearch}
                  className="w-[400px] p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {permissions && permissions.includes("blogs.create") && (
                  <>
                    <Link to="add-from-zip">
                      <VariantButton
                        props={{ onClick: null, title: "Thêm Blog từ ZIP" }}
                      />
                    </Link>
                    <Link to="add">
                      <VariantButton
                        props={{ onClick: null, title: "Thêm Blog" }}
                      />
                    </Link>
                  </>
                )}
              </div>
            </div>
            {filteredBlogs.length === 0 ? (
              <p className="text-gray-500 text-center py-4">
                Không tìm thấy blog nào.
              </p>
            ) : (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full table-auto border-collapse">
                    <thead>
                      <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                        <th className="py-3 px-6 text-left">Ngôn ngữ</th>
                        <th className="py-3 px-6 text-left">Tiêu đề</th>
                        <th className="py-3 px-6 text-left">Slug</th>
                        <th className="py-3 px-6 text-left">Loại</th>
                        <th className="py-3 px-6 text-left">Ảnh</th>
                        <th className="py-3 px-6 text-left">Tác giả</th>
                        <th className="py-3 px-6 text-left">Ngày tạo</th>
                        <th className="py-3 px-6 text-left">Nổi bật</th>
                        {permissions &&
                          (permissions.includes("blogs.update") ||
                            permissions.includes("blogs.delete")) && (
                            <th className="py-3 px-6 text-center">Hành động</th>
                          )}
                      </tr>
                    </thead>
                    <tbody className="text-gray-600 text-sm">
                      {currentBlogs.map((blog) => (
                        <tr
                          key={blog.id}
                          className="border-b border-gray-200 hover:bg-gray-50"
                        >
                          <td className="py-3 px-6 text-left">{blog.locale}</td>
                          <td className="py-3 px-6 text-left">{blog.title}</td>
                          <td className="py-3 px-6 text-left">{blog.slug}</td>
                          <td className="py-3 px-6 text-left">{blog.type}</td>
                          <td className="py-3 px-6 text-left">
                            {blog.image_url && (
                              <img
                                src={blog.image_url}
                                alt={blog.title}
                                className="w-16 h-16 object-cover rounded"
                              />
                            )}
                          </td>
                          <td className="py-3 px-6 text-left">{blog.author}</td>
                          <td className="py-3 px-6 text-left">
                            {new Date(blog.created_at).toLocaleDateString()}
                          </td>
                          <td className="py-3 px-6 text-left">
                            {featuredList && (
                              <input
                                type="checkbox"
                                onChange={() => handleIsFeaured(blog)}
                                checked={blog.featured}
                                className="cursor-pointer"
                              />
                            )}
                          </td>
                          {permissions &&
                            (permissions.includes("blogs.update") ||
                              permissions.includes("blogs.delete")) && (
                              <td className="py-3 px-6 text-center">
                                <div className="flex justify-center space-x-2">
                                  {permissions.includes("blogs.update") && (
                                    <Link
                                      to={`edit/${blog.id}`}
                                      className="text-yellow-500 hover:underline"
                                    >
                                      Sửa
                                    </Link>
                                  )}
                                  {permissions.includes("blogs.delete") && (
                                    <button
                                      onClick={() => handleDelete(blog.id)}
                                      disabled={deletingId !== null}
                                      className="text-red-500 hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                      Xóa
                                    </button>
                                  )}
                                </div>
                              </td>
                            )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {totalPages > 1 && (
                  <div className="mt-6 flex justify-center">
                    <nav className="flex items-center space-x-2">
                      <VariantButton
                        props={{
                          onClick: () => paginate(currentPage - 1),
                          title: "Trước",
                          disabled: currentPage === 1,
                        }}
                      />
                      {getPageNumbers().map((page, index) =>
                        page === "..." ? (
                          <span key={`ellipsis-${index}`} className="px-2">
                            ...
                          </span>
                        ) : (
                          <VariantButton
                            key={`page-${page}`}
                            props={{
                              onClick: () => paginate(page),
                              title: page,
                              selected: currentPage === page,
                            }}
                          />
                        ),
                      )}
                      <VariantButton
                        props={{
                          onClick: () => paginate(currentPage + 1),
                          title: "Sau",
                          disabled: currentPage === totalPages,
                        }}
                      />
                    </nav>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    )
  );
}
